import React, { useEffect, useState } from 'react';
import Summarizer from "./components/summarizer"
import Navbar from './components/navbar';
import Header from './components/header';
import Footer from './components/footer';
import AppUsageCard from './components/Appusage';
import { ChakraProvider } from '@chakra-ui/react';
const MyComponent = () => {



  return (
    <div>
        <ChakraProvider>
      <Navbar/>
      <Header/>
      <AppUsageCard/>
<Summarizer/>
<Footer/>
</ChakraProvider>
    </div>
  );
};

export default MyComponent;
